import React from 'react';
import './navbar.css';
import lg from '../images/ecell.PNG';


export default function Navbar() {
    return (
        <div>
            <div className='navbar'>
                <img src={lg} alt='err' />
               <div className='list'>
                <li>Home</li>
                <li>Team</li>
                <li>E-summit</li>
                <li>Activities</li>
                <li>Contact</li>
            </div>
            </div>
        </div>
    );
}


